const normalizeText = (value) => String(value || '').trim().toLowerCase();

const getOrderIdentityText = (order = {}) => [
  order.orderId,
  order.id,
  order.source,
  order.salesChannel,
  order.channel,
  order.origin,
].map(normalizeText).join(' ');

export const getOrderCountdownMinutes = (order = {}) => {
  const identity = getOrderIdentityText(order);
  const fulfillment = normalizeText(order.fulfillment);
  const orderType = normalizeText(order.orderType);
  const deliveryMode = normalizeText(order?.delivery?.mode || order.deliveryMode);

  const isSalon = (
    identity.includes('salao') ||
    identity.includes('salão') ||
    fulfillment === 'dine_in'
  );
  if (isSalon) return 15;

  const isBalcao = identity.includes('balcao') || identity.includes('balcão');
  if (!isBalcao) return 45;

  const isDelivery = (
    fulfillment === 'delivery' ||
    orderType === 'delivery' ||
    deliveryMode === 'delivery'
  );
  return isDelivery ? 45 : 15;
};
